/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
//import { domain} from '@/gloabelConstant.js'
export default {
    GetLibrary(context, model) {
        return new Promise((resolve, reject) => {
            debugger;
            axios
                .get("/API/Library/GetLibrary?ID=" + model)
                .then((response) => {
                    debugger;
                    console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GetAllLibraryCategory(context) {
        return new Promise((resolve, reject) => {
            debugger;
            axios
                .get("api/LibraryCategory/GetAll")
                .then(response => {
                    //    commit("SET_LibraryCategories", response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    GetItemByID(context, itemid) {
        return new Promise((resolve, reject) => {
            //debugger;
            axios
                .get("api/Library/GetLibraryForAdmin?ID=" + itemid)
                .then(response => {
                    // commit("UPDATE_Library", response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    GetAllBooks(context, model) {
        debugger;
        // mkl
        return new Promise((resolve, reject) => {
            axios
                .post("/API/Library/GetAllBooks", model)
                .then((response) => {
                    resolve(response);
                    commit("SET_Users", response.data.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GetAllVideos(context, model) {
        debugger;
        return new Promise((resolve, reject) => {
            axios
                .post("/API/Library/GetAllVideos", model)
                .then((response) => {
                    resolve(response);
                    // commit("SET_Users", response.data.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GetArticle(context, model) {
        return new Promise((resolve, reject) => {
            debugger;
            axios
                .get("/API/Article/GetArticle?ID=" + model)
                .then((response) => {
                    debugger;
                    console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GetNews(context, model) {
        return new Promise((resolve, reject) => {
            debugger;
            axios
                .get("/API/News/GetNews?ID=" + model)
                .then((response) => {
                    debugger;
                    console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GetAllLibraryAuth(context) {
        return new Promise((resolve, reject) => {
            debugger;
            axios
                .get("api/LibraryAuthor/GetAll")
                .then(response => {
                    //    commit("SET_LibraryCategories", response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    addComplain(context, item) {
        debugger
        return new Promise((resolve, reject) => {
            axios
                .post("API/ContactUs/AddContact", item)
                .then((response) => {
                    debugger;
                    console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};